import { List, ListItem, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export const BareCampsite = () => {
  return (
    <div className="page">
      <Typography gutterBottom variant="h3" align="center">
        YOU ARE IN BEAR COUNTRY!
      </Typography>
      <Typography gutterBottom variant="h5" align="center">
        "Bare" campsite policy in effect
      </Typography>
      <Typography sx={{ fontWeight: "bold" }}>
        We have a "bare" campsite program in place.
      </Typography>
      <Typography>
        By camping here, you are agreeing to take any garbage and food waste to
        the bear-proof bin located in the overflow parking lot at the front of
        the park, and to store ALL food and food-related items in the trunk of
        your vehicle or in a hard-sided trailer or RV. Tents and tent trailers
        are not bear-proof! Staff patrol the campground to ensure that sites are
        left clean and "bare".
      </Typography>
      <Typography sx={{ fontWeight: "bold" }}>
        Failure to comply with this policy will result in immediate eviction
        from the campground, without refund.
      </Typography>

      <Typography>
        Camping here, you are sharing space with wildlife such as bears,
        coyotes, wolves and others, who depend on this environment for their
        survival. Anything that has an odour or could be considered food may
        attract wildlife. If left unattended, items such as food, garbage and
        scented products may attract bears and other wildlife to your site,
        putting both humans and wildlife at risk.
      </Typography>

      <Typography sx={{fontWeight: 'bold'}}>
        Never leave ANY of these items unattended at your campsite:
      </Typography>

      <List
        sx={{
          paddingTop: 0,
          listStyleType: "disc",
          pl: 2,
          "& .MuiListItem-root": {
            display: "list-item",
          },
        }}
      >
        <ListItem sx={{ pl: 0 }}>
          Food - open or closed
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Coolers - full or empty
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Garbage, food waste, wrappings
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Unwashed dishes, pots, pans
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Pet food or bowls
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Bottles, cans
        </ListItem>
        <ListItem sx={{ pl: 0 }}>
          Scented products such as shampoo, soaps, candles, citronella, etc.
        </ListItem>
        
      </List>
    </div>
  );
};
